import { render, staticRenderFns } from "./CardListWrapper.vue?vue&type=template&id=2777e714&"
import script from "./CardListWrapper.vue?vue&type=script&lang=js&"
export * from "./CardListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CardListWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports